import { ChevronDown, ChevronUp } from "lucide-react";
import React from "react";

interface ChangeHistoryHeaderProps {
  isCollapsed: boolean;
  onToggle: () => void;
  itemCount: number;
}

const ChangeHistoryHeader: React.FC<ChangeHistoryHeaderProps> = ({
  isCollapsed,
  onToggle,
  itemCount
}) => {
  return (
    <div
      className="tw-p-4 tw-flex tw-items-center tw-justify-between tw-cursor-pointer hover:tw-bg-foreground/5 tw-border-b tw-border-border"
      onClick={onToggle}
    >
      <div className="tw-flex tw-items-center tw-gap-3">
        <h2 className="tw-text-lg tw-font-display tw-font-bold tw-text-foreground">
          Change History
        </h2>
      </div>
      {isCollapsed ? (
        <ChevronDown className="tw-h-5 tw-w-5 tw-text-foreground" />
      ) : (
        <ChevronUp className="tw-h-5 tw-w-5 tw-text-foreground" />
      )}
    </div>
  );
};

export default ChangeHistoryHeader;
